import { getLocale } from "../runtime";

const sv_campaign = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `kampanjer`
};

const campaign = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaign(inputs)
	return "campaign";
};

export { campaign as "campaign" };